import { createRouter, createWebHistory } from 'vue-router'
import '../../src/assets/vendor/@fortawesome/fontawesome-free/css/all.min.css'
// import'../../src/assets/vendor/line-awesome/dist/line-awesome/css/line-awesome.min.css'
import '../../src/assets/vendor/remixicon/fonts/remixicon.css'

const prepwiseAuthRoutes = (prop, mode) => [
  {
    path: "login",
    name: prop + ".login",
    meta: { requiresVisitors: true, name: "Login" },
    component: () => import("../views/Auth/LoginV1.vue")
  },
  {
    path: "register",
    name: prop + ".register",
    meta: { requiresVisitors: true, name: "Register" },
    component: () => import("../views/Auth/RegisterV1.vue")
  },
  {
    path: "activate",
    name: prop + ".activate",
    meta: { requiresVisitors: true, name: "Activate" },
    component: () => import("../views/Auth/ActivateV1.vue")
  },
  {
    path: "quick-profile",
    name: prop + ".QuickProfile",
    meta: { requiresVisitors: true, name: "QuickProfile" },
    component: () => import("../views/Auth/QuickProfileV1.vue")
  },
  {
    path: "forgotPassword",
    name: prop + ".forgotPassword",
    meta: { requiresVisitors: true, name: "forgotPassword" },
    component: () => import("../views/Auth/ForgotPasswordV1.vue")
  },
  {
    path: "resetPassword",
    name: prop + ".resetPassword",
    meta: { requiresVisitors: true, name: "resetPassword" },
    component: () => import("../views/Auth/ResetPasswordV1.vue")
  },
  {
    path: "ContactUs",
    name: prop + '.ContactUs',
    meta: { auth: true, name: 'ContactUs' },
    component: () => import('../views/Prepwise/WebFlowContactUsV2.vue')
  }
]
const prepwiseRoutes = (prop, mode) => [
  {
    path: "home",
    name: prop + ".home",
    meta: { requiresAuth: true, name: "home" },
    component: () => import("../views/Prepwise/Home.vue")
  },
  {
    path: "analytics",
    name: prop + ".analytics",
    meta: { requiresAuth: true, name: "analytics" },
    component: () => import("../views/Prepwise/Analytics.vue")
  },
  {
    path: 'profile',
    name: prop + '.profile',
    meta: { auth: true, name: 'Profile' },
    component: () => import('../views/Prepwise/Profile.vue')
  },
  {
    path: "/practice",
    name: prop + ".practice",
    meta: { requiresAuth: true, name: "practice" },
    component: () => import("../views/Prepwise/TestSeriesMain.vue")
  },
  {
    path: "/exams",
    name: prop + ".exams",
    meta: { requiresAuth: true, name: "exams" },
    component: () => import("../views/Prepwise/TestSeriesMain.vue")
  },
  {
    path: 'resources',
    name: prop + '.resources',
    meta: { auth: true, name: 'resources' },
    component: () => import('../views/Prepwise/ResourceList.vue')
  },
  {
    path: 'resource/:resourceId',
    name: prop + '.resource',
    meta: { auth: true, name: 'resource' },
    component: () => import('../views/Prepwise/ResourceView.vue')
  },
  {
    path: 'faqs_list',
    name: prop + '.faqs_list',
    meta: { auth: true, name: 'faqs_list' },
    component: () => import('../views/Prepwise/FAQsList.vue')
  },
  {
    path: 'notifications',
    name: prop + '.notifications',
    meta: { auth: true, name: 'notifications' },
    component: () => import('../views/Prepwise/Notifications.vue')
  },
  {
    path: "my_billing_history",
    name: prop + ".my_billing_history",
    meta: { auth: true, name: "my_billing_history" },
    component: () => import("../views/Prepwise/MyBillingHistory.vue")
  },
  {
    path: "attempts/:appId",
    name: prop + ".attempts",
    meta: { requiresAuth: true, name: "attempts" },
    component: () => import("../views/Prepwise/TPrepAttemptList.vue")
  },
  {
    path: "app_result_view_v1/:appId/:userId/:aprsId/:attemptNo",
    name: prop + ".app_result_view_v1",
    meta: { requiresAuth: true, name: "app_result_view_v1" },
    component: () => import("../views/Quiz/QuizResultViewV1.vue")
  },
  {
    path: "quiz_detail/:quizId",
    name: prop + ".quiz_detail",
    meta: { requiresAuth: true, name: "quiz_detail" },
    component: () => import("../views/Quiz/QuizDetail.vue")
  },
  {
    path: "subscription_plans",
    name: prop + ".subscription_plans",
    meta: { requiresAuth: true, name: "subscription_plans" },
    component: () => import("../views/Prepwise/SubscriptionPlans.vue")
  },
  {
    path: "pay_gw_status",
    name: prop + ".pay_gw_status",
    meta: { auth: true, name: "pay_gw_status" },
    component: () => import ("../views/Paygw/Paygw_status.vue")
  },
  {
    path: "pay_gw",
    name: prop + ".pay_gw",
    meta: { auth: true, name: "pay_gw" },
    component: () => import ("../views/Paygw/Paygw.vue")
  },
  {
    path: "app_result_analyse_v1/:appId/:gide_user_id/:aprsId",
    name: prop + ".app_result_analyse_v1",
    meta: { requiresAuth: true, name: "app_result_analyse_v1" },
    component: () => import('../views/Prepwise/AnswerAnalysis.vue')
  },
  {
    path: "quiz_question_view/:qbk_id/",
    name: prop + ".quiz_question_view",
    meta: { requiresAuth: true, name: "quiz_question_view" },
    component: () => import('../views/QuizBank/QuestionQuizViewV1.vue')
  }
]
const quizChildRoutes = (prop, mode) => [
  {
    path: "quiz/:appId",
    name: prop + ".quiz",
    meta: { requiresAuth: true, name: "quiz" },
    component: () => import("../views/Quiz/QuestionQuizFullPage.vue")
  }
]
const prepwiseWebflowHeaderFooter = (prop, mode) => [
 {
    path: "blogs",
    name: prop + ".blogs",
    meta: { name: "blogs" },
    component: () => import('../views/Prepwise/GideBlogList.vue')
  },
  {
    path: "blog/:blogId",
    name: prop + ".blog",
    meta: { name: "blog" },
    component: () => import("../views/Prepwise/GideBlogView.vue")
  },
  {
    path: 'faqs',
    name: prop + '.faqs',
    meta: { name: 'faqs' },
    component: () => import('../views/Prepwise/FAQsList.vue')
  }
]

const routes = [
  {
    path: "/",
    name: "prepwise",
    component: () => import('../layouts/PrepwiseMainContentLayoutNoSidebar.vue'),
    children: prepwiseRoutes("prepwise")
  },

  {
    path: "/assessment",
    name: "assessment",
    component: () => import('../layouts/QuizLayout.vue'),
    children: quizChildRoutes("quiz")
  },
  {
    path: "/",
    name: "prepwise_auth",
    component: () => import('../layouts/PrepwiseAuthLayout.vue'),
    children: prepwiseAuthRoutes("prepwise_auth")
  },
  {
    path: "/",
    name: "webflowHeaderFooter",
    component: () => import('../layouts/WebflowLayoutHeaderFooter.vue'),
    children: prepwiseWebflowHeaderFooter("webflowHeaderFooter")
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  base: process.env.BASE_URL,
  routes
})

export default router
